/* eslint-disable react/no-string-refs */
import PropTypes from 'prop-types'
import React from 'react'
import './index.scss'

let Draft

class Editor extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      editorState: null
    }
  }

  componentDidMount () {
    // If it's in the browser load 'draft-js'
    if (BROWSER) {
      this.loadDraftJs()
        .then(this.initialize.bind(this))
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line
    if (!this.state.editorState) {
      return
    }
    if (this.props.value != null && nextProps.value == null) {
      this.initialize(nextProps)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      !prevState.editorState &&
      this.state.editorState &&
      this.props.shouldFocusOnMount
    ) {
      this.focus()
      this.moveFocusToEnd()
    }
  }

  handleChange (editorState) {
    this.setState({ editorState })
    this.triggerOnChange(editorState)
  }

  handleClick () {
    this.focus()
  }

  focus () {
    this.refs.editor.focus()
  }

  initialize (props = this.props) {
    const value = props.value || ''
    const editorState = Draft.EditorState.createWithContent(
      Draft.ContentState.createFromText(value)
    )
    this.setState({
      editorState
    })
  }

  async loadDraftJs () {
    Draft = await import(/* webpackChunkName: "draft-js" */ 'draft-js')
  }

  moveFocusToEnd () {
    // Move the cursor to the end
    const editorState = Draft.EditorState.moveFocusToEnd(this.state.editorState)
    this.setState({ editorState })
  }

  triggerOnChange (editorState) {
    const contentState = editorState.getCurrentContent()
    const text = contentState.getPlainText()
    if (this.props.value === text) {
      return
    }
    this.props.onChange(text)
  }

  render () { // While the `draft-js` module is loading, render a static element
    // @see `this.loadDraftJs`
    if (!this.state.editorState) {
      return <>{this.props.value}</>
    }
    return (
      <div className='editor' onClick={this.handleClick}>
        <Draft.Editor
          editorState={this.state.editorState}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
          ref='editor'
        />
      </div>
    )
  }
}

Editor.propTypes = {
  value: PropTypes.string,
  /**
   * The placeholder.
   * e.g. 'emailExample@gmail.com'
   * @type {string}
   */
  placeholder: PropTypes.string,
  shouldFocusOnMount: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}
export default Editor
